import type { TFrame } from './types';

const isFiniteNumber = (value: unknown): value is number => typeof value === 'number' && Number.isFinite(value);

export const isValidFrame = (frame: TFrame): boolean => {
  if (!frame || typeof frame !== 'object') {
    return false;
  }

  const { image, bbox } = frame;

  if (typeof image !== 'string' || image.trim().length === 0) {
    return false;
  }

  if (!bbox || typeof bbox !== 'object') {
    return false;
  }

  return (
    isFiniteNumber(bbox.x)
    && isFiniteNumber(bbox.y)
    && isFiniteNumber(bbox.width)
    && isFiniteNumber(bbox.height)
    && bbox.width > 0
    && bbox.height > 0
  );
};

export const validateFrames = (frames: TFrame[]): boolean => {
  if (!Array.isArray(frames) || frames.length === 0) {
    return false;
  }

  return frames.every(isValidFrame);
};
